<template>
  <fragment>
    <hero-header page-name="" hero-title="ourServices"/>
    <v-container class="my-10">
      <v-row class="my-10">
        <v-col cols="12" class="mb-10">
          <div v-html="$t('pageServices.intro')"></div>
        </v-col>
        <v-col cols="12" class="mb-10">
          <h1 class="text-center mb-5">
            {{ $t('pageServices.servicedBrands') }}
          </h1>
          <div v-html="$t('pageServices.servicedBrandsText')"></div>
        </v-col>
        <!--  <v-col cols="12" class="mb-10 warning py-5">
          <div v-html="$t('asusNotText')" class="text-center"></div>
        </v-col> -->
        <template v-for="(brand, index) in $store.state.brandStore.brands">
          <v-col cols="12" sm="4" md="3" :key="index">
            <v-row justify="center">
              <brand-card-alternate v-bind:brand="brand" />
            </v-row>
          </v-col>
        </template>
      </v-row>
    </v-container>
    <!-- MIERT VALASSZ MINKET SECTION START -->
    <v-container fluid class="blue-stripes-bg">
      <v-container class="mt-10">
        <v-row class="my-10">
          <v-col cols="12" md="4">
            <h1 class="display-2 font-weight-bold white--text">
              {{ $t('whyChooseUs') }}
            </h1>
          </v-col>
          <v-col cols="12" md="8">
            <v-row>
              <v-col cols="12" sm="6" v-for="(item, index) in $store.state.generalStore.whyUs" :key="index" class="pt-0">
                <why-us v-bind:why-us="item" />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </v-container>
    <!-- MIERT VALASSZ MINKET SECTION START -->
    <!-- SZOLGALTATASOK SECTION START -->
    <v-container fluid id="sc">
      <v-container class="mt-5 mb-10">
        <v-row class="mt-5 mb-10">
          <v-col cols="12" class="mb-10">
            <h1 class="text-center">
              {{ $t('pageServices.complexSolutions') }}
            </h1>
          </v-col>
          <v-col cols="12" sm="6" v-for="(item, index) in $store.state.generalStore.services" :key="index" :id="item.id">
            <v-row :justify="index % 2 === 0 ? 'end' : 'start'" :class="$vuetify.breakpoint.smAndDown ? 'px-3 mb-10' : 'px-8 mb-10'" style="height: 100%;">
              <service-box v-bind:service="item" :show-desc="true"/>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </v-container>
    <!-- SZOLGALTATASOK SECTION END -->
    <!-- PARTNERS SECTION START -->
    <!--v-container class="my-10">
      <v-row class="my-10">
        <v-col cols="12" class="mb-10">
          <p class="primary--text text-center">
            {{ $t('partners') }}
          </p>
          <h1 class="text-center">
            {{ $t('hightTechSectorFromAtoZ') }}
          </h1>
        </v-col>
        <v-col cols="12">
          <v-row justify="space-between" align="center">
            <v-col cols="3" md="2" v-for="(partner, index) in brands" :key="index">
              <v-img :src="require(`../assets/${partner.img_path}`)" :alt="partner.title"/>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container-->
    <!-- PARTNERS SECTION START -->
  </fragment>
</template>

<script>
import heroHeader from '../components/heroHeader.vue';
import brandCard from '../components/brandCard.vue';
import brandCardAlternate from '../components/brandCardAlternate.vue';
import serviceBox from '../components/serviceBox.vue';
import whyUs from '../components/whyUs.vue';
import { BRAND_GET_SERVICEABLE_BRANDS } from '../store/getters.type';

export default {
  name: 'services',
  components: {
    heroHeader, brandCard, serviceBox, whyUs, brandCardAlternate,
  },
  async beforeMount() {
    this.getServiceableBrands();
  },
  data() {
    return {
      services: [],
      whyUs: [],
    };
  },
  methods: {
    async getServiceableBrands() {
      try {
        const response = await this.$store.dispatch(BRAND_GET_SERVICEABLE_BRANDS);
        if (!response.error && response.data) {
        }
      } catch (err) {
      }
    },
  },
};
</script>

<style scoped>

</style>
